import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/DashboardHome.vue')
    },
    {
      path: '/daily',
      name: 'daily-list',
      component: () => import('@/views/DailyDocsView.vue')
    },
    {
      path: '/daily/:date',
      name: 'daily-viewer',
      component: () => import('@/views/DailyDocViewer.vue')
    },
    {
      path: '/reference',
      name: 'reference-list',
      component: () => import('@/views/ReferenceView.vue')
    },
    {
      path: '/reference/:path(.*)',
      name: 'reference-viewer',
      component: () => import('@/views/ReferenceViewer.vue')
    },
    {
      path: '/sql',
      name: 'sql-list',
      component: () => import('@/views/SqlLibraryView.vue')
    },
    {
      path: '/sql/:file',
      name: 'sql-viewer',
      component: () => import('@/views/SqlViewer.vue')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('@/views/SearchView.vue')
    }
  ]
})

export default router
